import React from 'react';
import PropTypes from 'prop-types';
import css from './Dicon.module.less';

const Dicon = ({
  name,
  theme = 'light',
  size = 'sm',
  className = '',
  ...otherProps
}) => {
  const classes = [css.dicon, css[theme], css[size], className];

  // If type is 'skill-builder', correct the name to 'exercise'
  if (name === 'skill-builder') name = 'exercise';
  // If type is 'interactive worksheet', correct the name to 'worksheet'
  if (name === 'interactive worksheet') name = 'worksheet';

  return (
    <svg className={classes.join(' ')} {...otherProps}>
      <use xlinkHref={'#dicon-' + name} />
    </svg>
  );
};

Dicon.propTypes = {
  name: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['light', 'dark', 'yellow', 'red', 'orange']),
  size: PropTypes.oneOf(['sm', 'lg', 'xl', 'largeImage']),
  className: PropTypes.string,
};

export default Dicon;
